if (typeof window.ajaxFiltersEnabled === 'undefined') {
  window.ajaxFiltersEnabled = true;
}
(function() {
// Filter Drawer Controller
const filterButton = document.querySelector('.t4s-btn-filter');
const filterDrawer = document.getElementById('t4s-filter-hidden');
let activeFilterAbortController = null;
let filterActive = false;
let previousBodyOverflow = '';

function closeDrawer() {
  filterActive = false;
  filterDrawer.setAttribute('hidden', '');
  
  document.body.style.overflow = previousBodyOverflow || '';
  removeOverlay();

  if (typeof removeTrapFocus === 'function') {
    removeTrapFocus(filterDrawer);
  }

  if (filterButton) {
    filterButton.setAttribute('aria-expanded', 'false');
    filterButton.focus();
  }
}

if (filterButton) {
  filterButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    filterActive = !filterActive;
    filterButton.setAttribute('aria-expanded', filterActive.toString());

    if (filterActive) {
      previousBodyOverflow = document.body.style.overflow;
      filterDrawer.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      createOverlay();
      if (typeof trapFocus === 'function') {
        trapFocus(filterDrawer);
      }

    } else {
      closeDrawer();
    }
  });
}

// Close drawer when close button is clicked
function bindCloseButton() {
  const closeBtn = document.querySelector('#t4s-filter-hidden .t4s-filter-drawer__close');

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    });
  }
}

// Dynamically restore filter order to match original order (not sorted by count)
function restoreDynamicFilterOrder() {
    const filterGroups = document.querySelectorAll('.t4s-filter-options');
    
    filterGroups.forEach((group) => {
        // Get the filter group title (Grade, Subject, etc.) from the parent
        const groupContainer = group.closest('.t4s-filter-group');
        const titleElement = groupContainer ? groupContainer.querySelector('.t4s-filter-group__title') : null;
        const groupTitle = titleElement ? titleElement.textContent.trim() : null;
        
        if (!groupTitle) return;
        
        // Create a unique storage key for this filter group
        const pageId = window.location.pathname; // simple and effective
        const storageKey = `filter-original-order-${pageId}-${groupTitle}`;
        let originalOrder = null;

        try {
            originalOrder = JSON.parse(sessionStorage.getItem(storageKey));
        } catch (e) {
            originalOrder = null;
        }   
     
        // Get current filter options
        const options = Array.from(group.querySelectorAll('.t4s-filter-option'));
        const currentLabels = options.map(opt => opt.querySelector('.t4s-filter-option__label').textContent.trim());
        
        // On first load, capture and store the original order as reference
        if (!originalOrder) {
            originalOrder = [...currentLabels];
            try {
                sessionStorage.setItem(storageKey, JSON.stringify(originalOrder));
            } catch (e) {
                // Ignore storage write failures and continue using the in-memory order
            }
        }
        
        // Sort options based on the stored original order
        options.sort((a, b) => {
            const labelA = a.querySelector('.t4s-filter-option__label').textContent.trim();
            const labelB = b.querySelector('.t4s-filter-option__label').textContent.trim();
            
            const indexA = originalOrder.indexOf(labelA);
            const indexB = originalOrder.indexOf(labelB);
            
            // If item is new (not in original order), place it at the end
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
        });
        
        // Apply CSS flexbox ordering to reorder the display
        group.style.display = 'flex';
        group.style.flexDirection = 'column';
        
        options.forEach((option, index) => {
            option.style.order = index;
        });
    });
}

// Overlay for mobile
function createOverlay() {
    if (document.querySelector('.t4s-filter-overlay')) return;
    
    const overlay = document.createElement('div');
    overlay.className = 't4s-filter-overlay';
    overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
    cursor: pointer;
    `;
    
    overlay.addEventListener('click', function() {
        closeDrawer();
    });
    
    document.body.appendChild(overlay);
}

function removeOverlay() {
    const overlay = document.querySelector('.t4s-filter-overlay');
    if (overlay) {
    overlay.remove();
    }
}

// Keyboard escape key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape' && filterActive) {
    closeDrawer();
  }
});

// Handle price filter
function bindPriceFilter() {
  const minInput = document.querySelector('[data-filter-min], input[name="filter.v.price.gte"]');
  const maxInput = document.querySelector('[data-filter-max], input[name="filter.v.price.lte"]');

  if (minInput && maxInput) {
    const applyPrice = () => {
      const minValue = minInput.value;
      const maxValue = maxInput.value;

      const url = new URL(window.location.href);
      url.hash = '';

      const baseUrl = url.origin + url.pathname;
      let filterUrl = baseUrl;

      const params = url.searchParams;

      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');

      if (minValue) {
        params.set('filter.v.price.gte', minValue);
      }
      if (maxValue) {
        params.set('filter.v.price.lte', maxValue);
      }

      const queryString = params.toString();
      filterUrl = queryString ? baseUrl + '?' + queryString : baseUrl;

      if (window.ajaxFiltersEnabled) {
        applyFiltersAjax(filterUrl);
      } else {
        window.location.assign(filterUrl);
      }
    };

    const handlePriceKeyDown = function(event) {
      const key = event.key || event.keyCode;
      if (key === 'Enter' || key === 13) {
        if (typeof event.preventDefault === 'function') {
          event.preventDefault();
        }
        applyPrice();
      }
    };

    minInput.addEventListener('keydown', handlePriceKeyDown);
    maxInput.addEventListener('keydown', handlePriceKeyDown);
  }
}

function bindFilterEvents() {
  const filterOptions = document.querySelectorAll('.t4s-filter-option__input');

  filterOptions.forEach(option => {
    option.addEventListener('change', () => {
      const baseUrl = option.dataset.filterUrl || window.location.href;
      const currentUrl = new URL(baseUrl, window.location.origin);
      const params = new URLSearchParams(currentUrl.search);
      const param = option.dataset.filterParam;
      const value = option.dataset.filterValue;

      if (param && value) {
        const remainingValues = params.getAll(param).filter(existingValue => existingValue !== value);
        params.delete(param);
        remainingValues.forEach(existingValue => {
          params.append(param, existingValue);
        });

        if (option.checked) {
          params.append(param, value);
        }
      }
      
      const queryString = params.toString();
      const finalUrl = queryString ? `${currentUrl.pathname}?${queryString}` : currentUrl.pathname;

      if (window.ajaxFiltersEnabled) {
        applyFiltersAjax(finalUrl);
      } else {
        window.location.assign(finalUrl);
      }
    });
  });
}
restoreDynamicFilterOrder();
bindFilterEvents();
bindCloseButton();
bindPaginationEvents();
bindTopTileFilters();
bindPriceFilter();

function bindPaginationEvents() {
  const links = document.querySelectorAll('.course-pagination a');

  links.forEach(link => {
    link.addEventListener('click', function(e) {
      const isUnmodifiedLeftClick =
        e.button === 0 &&
        !e.metaKey &&
        !e.ctrlKey &&
        !e.shiftKey &&
        !e.altKey;

      if (!isUnmodifiedLeftClick) {
        return;
      }

      const url = this.getAttribute('href');
      if (!url) return;

      if (window.ajaxFiltersEnabled) {
        e.preventDefault();
        applyFiltersAjax(url);
      }
    });
  });
}

function applyFiltersAjax(url, shouldPushState = true) {
  // Abort any in-flight request
  if (activeFilterAbortController) {
    activeFilterAbortController.abort();
  }

  activeFilterAbortController = new AbortController();
  const { signal } = activeFilterAbortController;

  fetch(url, { method: 'GET', signal })
    .then(response => {
      if (!response.ok) {
        throw new Error('Filter AJAX request failed with status ' + response.status);
      }
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Replace product grid
      const newGrid = doc.querySelector('.course-grid');
      const currentGrid = document.querySelector('.course-grid');

      if (!newGrid) {
        throw new Error('Filter AJAX response missing required .course-grid');
      }
      if (currentGrid) {
        currentGrid.innerHTML = newGrid.innerHTML;
      }

      // No results handling
      const newNoResults = doc.querySelector('.t4s-no-courses-message');
      let currentNoResults = document.querySelector('.t4s-no-courses-message');

      if (newNoResults && currentGrid) {
        if (currentNoResults) currentNoResults.remove();
        currentGrid.insertAdjacentElement('afterend', newNoResults);
      } else if (!newNoResults && currentNoResults) {
        currentNoResults.remove();
      }

      // Pagination
      const newPagination = doc.querySelector('.course-pagination');
      const currentPagination = document.querySelector('.course-pagination');

      if (newPagination && currentPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
        currentPagination.style.display = '';
      } else if (!newPagination && currentPagination) {
        currentPagination.remove();
      } else if (newPagination && !currentPagination) {
        const gridWrapper = document.querySelector('.course-grid');
        if (gridWrapper) {
          gridWrapper.insertAdjacentElement('afterend', newPagination);
        }
      }

      // Filter drawer
      const newDrawer = doc.querySelector('#t4s-filter-hidden');
      const currentDrawer = document.querySelector('#t4s-filter-hidden');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      // Applied filters
      const newFilters = doc.querySelector('.t4s-applied-filters-wrapper');
      const currentFilters = document.querySelector('.t4s-applied-filters-wrapper');

      if (newFilters && currentFilters) {
        currentFilters.innerHTML = newFilters.innerHTML;
      }

      // History update
      if (shouldPushState) {
        window.history.pushState({}, '', url);
      }

      restoreDynamicFilterOrder();

      // Re-bind AFTER DOM replacement
      bindFilterEvents();
      bindCloseButton();
      bindPaginationEvents();
      bindTopTileFilters();
      bindPriceFilter();
    })
    .catch(err => {
      // Ignore aborted requests silently
      if (err.name === 'AbortError') return;
      console.error('Filter AJAX error:', err);

      if (shouldPushState) {
        window.location.assign(url);
      } else {
        window.location.replace(url);
      }
    });
}

window.addEventListener('popstate', function () {
  const url = `${window.location.pathname}${window.location.search}`;

  if (!window.ajaxFiltersEnabled) {
    window.location.replace(url);
    return;
  }
  applyFiltersAjax(url, false);
});

function updateUrlParameter(param, value, options = {}) {
  const { toggle = true } = options;

  const url = new URL(window.location.href);
  const params = url.searchParams;
  const existingValues = params.getAll(param);

  if (toggle && existingValues.includes(value)) {
    params.delete(param);
    existingValues
      .filter(v => v !== value)
      .forEach(v => params.append(param, v));
  } else if (!existingValues.includes(value)) {
    params.append(param, value);
  }

  return (
    url.pathname +
    (params.toString() ? `?${params.toString()}` : '') +
    url.hash
  );
}

function bindTopTileFilters() {
  const filterTiles = document.querySelectorAll('.top-tile-filter');

  filterTiles.forEach(tile => {
    const { param, value } = tile.dataset;

    if (param && value) {
      tile.href = updateUrlParameter(param, value, { toggle: true });
    }

    if (tile.dataset.bound === 'true') return;
    tile.dataset.bound = 'true';

    tile.addEventListener('click', e => {
      if (!window.ajaxFiltersEnabled) return;

      const isModifiedClick =
        e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
      const isPrimaryButton = e.button === 0;

      if (isModifiedClick || !isPrimaryButton) return;

      e.preventDefault();

      if (!param || !value) return;

      const newUrl = updateUrlParameter(param, value, {
        toggle: true
      });

      applyFiltersAjax(newUrl);
    });
  });
}
})();